import BaseRepository from '@/repositories/base/BaseRepository'

class PeakDaySettingRepository extends BaseRepository {
	// 带客宝高峰日日历
	getPeakDayCalendar(params: any) {
		return this.get<any>({
			url: '/ebk-dkb-api/peak-day-setting/peak-day-calendar',
			data: params,
		})
	}
}

export default PeakDaySettingRepository
